module.exports = __webpack_public_path__ + "static/img/end04.caa7225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/end04.jpg
// module id = 1435
// module chunks = 0